import { API, root} from "./config.js";
import { sendData } from "./data.js";
import { init } from "./index.js";
import logo from 'url:../images/sprite.svg';

export const auth = () => {
    const authFormHTML = `
        <div class="login">
            <form class="login-form">
                <svg class="wd-icon login-logo">
                    <use xlink:href="${logo}#logo-text"></use>
                </svg>
                <input type="text" name="email" class="login-form__input login-email" placeholder="Введите E-mail">
                <input type="password" name="password" class="login-form__input password" placeholder="Введите пароль">
                <input type="submit" class="login-form__input primary-btn" value="Войти">
            </form>
        </div>
    `;
    root.insertAdjacentHTML('afterbegin', authFormHTML)

    document.querySelector('.login-form__input.primary-btn').addEventListener('click', e => {
        e.preventDefault();

        let authData = new FormData(document.querySelector('.login-form'));
        authData = Object.fromEntries(authData);

        sendData(`${API}login`, authData)
        .then(data => {
            if(data.status === true) {
                const bearer = data.data.token
                localStorage.setItem('token', bearer);
                init();
            }
        })
    })
}